import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseTableQuery, buildTableQuery } from '../utils/tableQuery';

/**
 * Ð¤Ð¸Ð»ÑÑÑÑ, Ð±ÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ¿Ð¸ÑÐºÐ° â Ð² Ð°Ð´ÑÐµÑÐ½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐµ.
 *
 * ÐÐµÐ· ÑÑÐ¾Ð³Ð¾ ÑÑÐ¾Ð´ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¸ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°Ð»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð½Ð° Ð¿ÐµÑÐ²ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ
 * Ð¿ÑÑÑÐ¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°: ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¶Ð¸Ð»Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÑÐµÐ¹ÑÐµ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¸ ÑÐ¼Ð¸ÑÐ°Ð»Ð¾ Ð²Ð¼ÐµÑÑÐµ Ñ Ð½ÐµÐ¹.
 *
 * Ð¥ÑÐºÐ° Ð´Ð²Ð°, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¿Ð¾ÑÑÐ´Ð¾Ðº Ð²ÑÐ·Ð¾Ð²Ð¾Ð² Ð² ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐµ Ð¾Ð±ÑÐ°ÑÐ½ÑÐ¹ ÑÐ²ÑÐ·Ð¸ Ð¼ÐµÐ¶Ð´Ñ Ð½Ð¸Ð¼Ð¸:
 * Ð·Ð½Ð°ÑÐµÐ½Ð¸ÑÐ¼Ð¸ Ð¸Ð· Ð°Ð´ÑÐµÑÐ° Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÑÐµÑÑÑ ÑÑÐµÐ¹Ñ (Ð·Ð½Ð°ÑÐ¸Ñ, ÑÐ¸ÑÐ°ÑÑ Ð°Ð´ÑÐµÑ Ð½Ð°Ð´Ð¾ ÐÐ
 * useState), Ð° Ð¿Ð¸ÑÐ°ÑÑ Ð² Ð°Ð´ÑÐµÑ Ð½ÑÐ¶Ð½Ð¾ ÑÐ¶Ðµ Ð³Ð¾ÑÐ¾Ð²ÑÐ¹ ÑÑÐµÐ¹Ñ.
 */

/** Ð Ð°Ð·Ð±Ð¾Ñ Ð°Ð´ÑÐµÑÐ° â Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¿ÑÐ¸ Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸: Ð´Ð°Ð»ÑÑÐµ Ð°Ð´ÑÐµÑ Ð¿Ð¸ÑÐµÐ¼ Ð¼Ñ ÑÐ°Ð¼Ð¸. */
export const useInitialTableQuery = (filterNames) => {
  const [searchParams] = useSearchParams();
  return useRef(parseTableQuery(searchParams, filterNames)).current;
};

/** ÐÐ°Ð¿Ð¸ÑÑ ÑÐµÐºÑÑÐµÐ³Ð¾ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ Ð² Ð°Ð´ÑÐµÑ. */
const useTableUrlSync = ({ queryParams, page, pageSize }) => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    // replace, Ð° Ð½Ðµ push: Ð¸Ð½Ð°ÑÐµ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð¿ÑÐ¸ÑÐ»Ð¾ÑÑ Ð±Ñ Ð¶Ð°ÑÑ ÑÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð·, ÑÐºÐ¾Ð»ÑÐºÐ¾
    // Ð¿Ð¾Ð»ÐµÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾ÑÑÐ¾Ð³Ð°Ð».
    setSearchParams(buildTableQuery(queryParams, page, pageSize), { replace: true });
  }, [queryParams, page, pageSize]);
};

export default useTableUrlSync;
